import React from 'react'
import Grid from 'material-ui/Grid'
import Paper from 'material-ui/Paper'
import Button from 'material-ui/Button'
import Add from '@material-ui/icons/Add'
import Slide from 'material-ui/transitions/Slide'
import { withStyles } from 'material-ui/styles'
import Dialog from 'material-ui/Dialog'
import compose from 'lodash/fp/compose'
import createState from "react-copy-write"

import NewClientForm from '../containers/NewClientForm'
import ClientsDataGrid from '../containers/CurrentCustomersGrid'

const { Provider, Consumer } = createState({
  open: false,
  editingId: null
});

const styles = theme => ({
  fab: {
    position: 'absolute',
    bottom: theme.spacing.unit * 2,
    right: theme.spacing.unit * 2,
  }
})

function Transition(props) {
  return <Slide direction="up" {...props} />
}

const ClientsPage = ({ classes }) =>
  <Provider>
    <Grid container>
      <Grid item xs={12}>
        <Paper elevation={4}>
          <Consumer>
            {(state, mutate) => (
              <ClientsDataGrid onEdit={customerId => mutate(draft => {
                draft.editingId = customerId
                draft.open = true
              })} />
            )}
          </Consumer>
        </Paper>
      </Grid>
    </Grid>
    <Consumer>
      {(state, mutate) => (
        <React.Fragment>
          <Button className={classes.fab} color="secondary" variant="fab" onClick={() => mutate(draft => {
            draft.open = true
          })}>
            <Add />
          </Button>
          <Dialog
            fullScreen
            open={state.open}
            onClose={() => mutate(draft => {
              draft.open = false
              draft.editingId = null
            })}
            transition={Transition}
          >
            <NewClientForm customerId={state.editingId} handleClose={() => mutate(draft => {
              draft.open = false
              draft.editingId = null
            })} />
          </Dialog>
        </React.Fragment>
      )}
    </Consumer>
</Provider>

export default compose(
  withStyles(styles)
)(ClientsPage)


// WEBPACK FOOTER //
// ./src/modules/clients/components/ClientsPage.js